import { ApiUserData } from "../../../api-http/types";
import { PersonalAreaProfileFormFieldsTypes } from "../forms-fields/personal-area-profile-form-fields/types";

export const mapFormDataToApiPayload = (
  formData: PersonalAreaProfileFormFieldsTypes
): ApiUserData => ({
  businessRelationship: {
    id: formData.businessRelationship,
  },
  city: formData.city ?? "",
  company: formData.company,
  consents: Object.keys(formData.consents).map((key) => ({
    status: formData.consents[key] ? "active" : "inactive",
    consentId: key,
  })),
  country: {
    id: formData.country,
  },
  email: formData.email,
  firstName: formData.firstName,
  lastName: formData.lastName,
  materials: formData.materials?.map((material) => ({ id: material })),
  phone: formData.phone,
  province:
    !formData.stateId && !formData.state
      ? undefined
      : {
          id: formData.stateId ?? undefined,
          value: formData.state ?? undefined,
        },
  zipCode: formData.zipCode,
});

export const mapApiPayloadToFormData = (
  apiPayload: ApiUserData
): PersonalAreaProfileFormFieldsTypes => {
  let consents: Record<string, boolean | null> = {};
  apiPayload.consents.forEach((consent) => {
    consents[consent.consentId] = consent.status === "active";
  });
  return {
    businessRelationship: apiPayload.businessRelationship?.id ?? "",
    city: apiPayload.city,
    company: apiPayload.company,
    country: apiPayload.country?.id ?? "",
    email: apiPayload.email,
    firstName: apiPayload.firstName,
    lastName: apiPayload.lastName,
    materials:
      (apiPayload.materials
        ?.map((material) => material.id)
        ?.filter((x) => x !== undefined) as string[]) ?? [],
    phone: apiPayload.phone,
    stateId: apiPayload.province?.id ?? null,
    state: apiPayload.province?.value ?? null,
    zipCode: apiPayload.zipCode,
    consents: consents ?? {},
  };
};
